import React, { Component } from 'react';
import { Icon } from 'semantic-ui-react';

import { __ } from '../../lib/I18n';
import Alert from '../Alert';

/**
 * @typedef {{
 *  value: string,
 *  sendTo: string,
 *  loginType: string,
 *  onChange: (password: string) =>void,
 *  onConfirm: () => void,
 *  recoverPassword: () => void,
 *  recoverSuccess: boolean?,
 *  closeAlert: () => void,
 *  placeholder?: string
 * }} Props
 * @extends {Component<Props>}
 */
export default class PasswordInput extends React.Component {
  /** @param {Props} props */
  constructor(props) {
    super(props);

    this.state = {
      error: '',
      showPassword: false,
      forgotPasswordSuccess: null,
    };
  }

  /**
   * @param {string} password
   * @returns {boolean}
   */
  validate = (password) => {
    if (!password.trim()) {
      this.onError();
      return false;
    }

    return true;
  };

  onConfirm = () => {
    const { value, onConfirm } = this.props;

    if (this.validate(value) && onConfirm) onConfirm();
  };

  onError = () => {
    this.setState({ error: 'Senha incorreta. Tente novamente ou clique em "Esqueceu a senha?" para redefini-la.' });
  };

  render() {
    const { error, showPassword, forgotPasswordSuccess } = this.state;
    const { value, onChange, sendTo, loginType, recoverPassword, recoverSuccess, closeAlert, placeholder } = this.props;

    return (
      <div className={`input-component ${error ? 'error' : ''}`} style={{ marginBottom: '2.5rem', maxWidth: '23rem', width: '100%' }}>
        {/* <div style={{ display: 'flex', alignItems: 'center' }}>
          <Icon className="angle left" />
          <p style={{ marginLeft: '.5rem' }}>Voltar</p>
        </div> */}
        <h5 style={{ marginBottom: '.5rem', marginLeft: '1rem' }}>{__('Senha')}</h5>
        <div className="text-input" style={{ marginBottom: '.8rem' }}>
          <input
            type={showPassword ? 'text' : 'password'}
            value={value}
            placeholder={placeholder}
            onChange={/** @param {any} e */ (e) => onChange(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && this.onConfirm()}
            style={{ fontWeight: 600, fontSize: 16 }}
          />
          <i
            className={`icon ${showPassword ? 'eye' : 'eye slash'} align-right`}
            onClick={() => this.setState({ showPassword: !showPassword })}
            onKeyPress={() => this.setState({ showPassword: !showPassword })}
          />
        </div>
        <a onClick={recoverPassword} onKeyPress={recoverPassword} style={{ cursor: 'pointer' }}>
          {__('Esqueceu a senha?')}
        </a>
        {forgotPasswordSuccess && (
          <p style={{ fontSize: 16, fontWeight: 400, color: '#6C6C6C' }}>
            {__(`Enviamos um link para o ${loginType === 'email' ? 'email' : 'número'} ${sendTo} para redefinir a sua senha`)}
          </p>
        )}
        {error && (
          <div className="error-warning" style={{ marginTop: '1rem' }}>
            <Icon className="circle exclamation" />
            <span>{__(error)}</span>
          </div>
        )}
        {recoverSuccess !== null && (
          <Alert
            visible={recoverSuccess !== null}
            type={recoverSuccess ? 'success' : 'error'}
            text={recoverSuccess ? `Enviamos um ${loginType === 'email' ? 'email' : 'SMS'} para ${sendTo}.` : 'Ocorreu um erro. Verifique a sua conexão e tente novamente.'}
            visibleTime={4000}
            style={{ marginTop: '.5rem' }}
            onClose={() => closeAlert()}
          />
        )}
      </div>
    );
  }
}
